import { Box } from "@mui/material";

interface KeyIndicatorProps {
  keyLabel: string;
  variant?: "light" | "dark";
}

export const KeyIndicator = ({
  keyLabel,
  variant = "dark",
}: KeyIndicatorProps) => {
  return (
    <Box
      sx={{
        px: 0.75,
        py: 0.25,
        borderRadius: 0.5,
        backgroundColor:
          variant === "dark" ? "rgba(0, 0, 0, 0.2)" : "rgba(0, 0, 0, 0.15)",
        fontSize: "0.75rem",
        fontFamily: "monospace",
        color: variant === "dark" ? "white" : "black",
        display: "inline-flex",
        alignItems: "center",
      }}
    >
      {keyLabel}
    </Box>
  );
};
